import { render, staticRenderFns } from "./relayDetail.vue?vue&type=template&id=4b66d1dc&scoped=true&"
import script from "./relayDetail.vue?vue&type=script&lang=js&"
export * from "./relayDetail.vue?vue&type=script&lang=js&"
import style0 from "./relayDetail.vue?vue&type=style&index=0&id=4b66d1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66d1dc",
  null
  
)

export default component.exports